import { useMemo } from "react";
import type { SortState } from "./DataTableTypes";
import { filterRows, type RowCriteria } from "./rowFilter";
import { sortRows } from "./rowSort";

export interface VisibleRowsInput<R> extends RowCriteria<R> {
  rows: R[];
  sort: SortState | undefined;
}

/** The rows that pass the search and filters, in the chosen order. */
export function useVisibleRows<R>({ rows, columns, query, filters, searchText, sort }: VisibleRowsInput<R>): R[] {
  const filtered = useMemo(
    () => filterRows(rows, { columns, query, filters, searchText }),
    [rows, columns, query, filters, searchText],
  );
  return useMemo(() => sortRows(filtered, columns, sort), [filtered, sort, columns]);
}
